/**
 * True when the user has set "reduce motion" at the OS level. Use to gate
 * JS-driven smooth scrolls / animations — CSS `@media (prefers-reduced-motion)`
 * already handles the rest.
 */
export function prefersReducedMotion(): boolean {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/** Convenience: instant scroll under reduced-motion, else the requested behavior. */
export function scrollBehavior(
  preferred: ScrollBehavior = 'smooth',
): ScrollBehavior {
  return prefersReducedMotion() ? 'auto' : preferred;
}
